var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.beerDetails)?_c('p',{staticClass:"caption ma-0"},[_vm._v(" "+_vm._s(_vm.beerDetails.stil)+" ("+_vm._s(_vm.beerDetails.alkoholhalt)+"%). ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }